import axios from 'axios';
import { clearStoredAuth, getStoredToken } from '../context/AuthContext';

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
});

httpClient.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearStoredAuth();
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

const unwrap = (response) => response.data?.data;

export async function listCredentials() {
  const response = await httpClient.get('/credentials/');
  return unwrap(response) ?? [];
}

export async function createCredential(name) {
  const response = await httpClient.post('/credentials/', null, {
    params: { name },
  });

  return unwrap(response);
}

export async function updateCredentialField(id, field, value, password) {
  const params = { value };

  if (password) {
    params.password = password;
  }

  const response = await httpClient.post(`/credentials/${id}/${field}`, null, {
    params,
  });

  return unwrap(response);
}

export async function decryptCredentialValue(value, password) {
  const response = await httpClient.get('/credentials/decrypt', {
    params: { value, password },
  });

  return unwrap(response);
}

const credentialService = {
  listCredentials,
  createCredential,
  updateCredentialField,
  decryptCredentialValue,
};

export default credentialService;